import React, { Dispatch, SetStateAction } from "react";

type AreFlagsDisplayedContext = {
  areFlagsDisplayed: boolean;
  setAreFlagsDisplayed: Dispatch<SetStateAction<boolean>>;
};

export default React.createContext<AreFlagsDisplayedContext>({
  areFlagsDisplayed: false,
  setAreFlagsDisplayed: (value) => {},
});
